<template>
  <intersect @enter="onEnter" @leave="onExit">
    <div class="indicator-card" :id="indicator.id">
      <div class="title">{{t(indicator.id)}}
        <div class="share-icon" @click="openShare" v-if="hasIndicatorData"></div>
      </div>
      <component
        class="card-content"
        ref="component"
        :is="cardComponent"
        :visible="visible"
        :indicator="indicator"
      />
      <div class="next-btn" v-if="!isMobile && hasNext" @click="$emit('next')">
        <div class="next-btn-text">{{t('click_to_scroll')}}</div>
      </div>
    </div>
  </intersect>
</template>

<script>
import Intersect from 'vue-intersect'
// import Api from '@/api'
import CommercialPulse from '@/components/IndicatorCards/CommercialPulse'
import Recovery from '@/components/IndicatorCards/Recovery'
import SectorsRanking from '@/components/IndicatorCards/SectorsRanking'
import TouristsRanking from '@/components/IndicatorCards/TouristsRanking'
import TicketsAvg from '@/components/IndicatorCards/TicketsAvg'
import SectorEvol from '@/components/IndicatorCards/SectorEvol.vue'
// import DigitalEvol from '@/components/IndicatorCards/DigitalEvol.vue'
import DigitalRanking from '@/components/IndicatorCards/DigitalRanking.vue'
import DigitalEvolRatio from '@/components/IndicatorCards/DigitalEvolRatio.vue'

export default {
  name: 'IndicatorCard',
  props: ['indicator','hasNext'],
  data () {
    return {
      visible: false
    }
  },
  computed: {
    cardComponent () {
      let componentsMap = {
        'pulse': CommercialPulse,
        'trust': Recovery,
        'sector_ranking': SectorsRanking,
        'tourism_ranking': TouristsRanking,
        'avg_ticket': TicketsAvg,
        'sector_evol': SectorEvol,
        // 'digital_evol': DigitalEvol,
        'digital_ranking': DigitalRanking,
        'digital_evol_ratio': DigitalEvolRatio,
      }
      return componentsMap[this.indicator.id]
     },
     hasIndicatorData () {
       return this.visible && this.$refs.component && this.$refs.component.hasData
     }
  },
  methods: {
    onEnter () {
      console.log('enter:' + this.indicator.id)
      this.visible = true
      this.$emit('indicatorEnter', this.indicator.id)
    },
    onExit () {
      console.log('exit:' + this.indicator.id)
      this.visible = false
      this.$emit('indicatorExit', this.indicator.id)
    },
    openShare (evt) {
      evt.stopPropagation()
      let text = this.$refs.component.$refs.textComponent.plain_text
      this.$emit('openSharePanel', {text: text, indicator: this.indicator.id})
    }
  },
  components: { Intersect }

}
</script>

<style lang="stylus">
.indicator-card
  position relative
  background: #fff
  display: flex
  display: flex
  flex-direction: column
  overflow hidden
  margin: vh(10px) vh(10px)
  padding: vh(10px) vw(10px)
  scroll-snap-align: start
    
  .desktop &
    // flex: 0 0 "calc(100% - %s)" % vh(20px)
    flex 0 0 100%
    margin 0
    padding: vh(50px) vw(50px)
    border-top solid 1px #ddd
  
  
  // quizas nos lo podemos ahorrar?
  .mobile &
    flex: 0 0 vh(400px)
    &#trust
      flex: 0 0 vh(650px)
    &#pulse
      flex: 0 0 vh(650px)
    &#sector_evol
      flex: 0 0 vh(710px)
    &#digital_evol
      flex: 0 0 vh(650px)
    &#digital_ranking
      flex: 0 0 vh(710px)
    &#digital_evol_ratio
      flex: 0 0 vh(690px)
    &#sector_ranking
      flex: 0 0 vh(690px)
    &#tourism_ranking
      flex: 0 0 vh(710px)
    &#avg_ticket
      flex: 0 0 vh(700px)
  .title
    font-family 'Anton'
    // text-transform: uppercase
    m-font-size(22, 30)
    letter-spacing: 0.25px;
    margin-bottom: vh(15px)
    display flex
    .mobile &
      m-font-size(24, 26)
    .share-icon
      margin-left auto
      cursor pointer
      background-image url('~@/assets/icons/share-icon.svg')
      background-position center center
      background-size contain
      background-repeat no-repeat
      width vw(19px)
      height vw(21px)
      .desktop &
        position absolute
        right vw(30px)
        top vw(40px)

  .card-content
    // background: #ccc
    // comon styles
    display: flex
    flex: 1 1 auto
    height: 100%
    .top,.botom
      position relative
    // min-height: vh(400px)
    .mobile &
      flex-direction: column
      //min-height: 80vh // vh(100vh)
      .top, .bottom
        flex: 0 0 auto
        z-index 1

      .top
        flex: 0 0 auto

      .bottom
        display: flex
        flex: 1 1 auto

    .desktop &
      flex-direction: row

      .top,.bottom
        flex 0 0 50%
      .top
        padding-right vw(150px)

    .bottom
      display: flex
      flex-direction: column

  .next-btn
    position absolute
    left 50%
    bottom vh(25px)
    transform translate(-50%,-50%)
    cursor pointer
    .next-btn-text
      font-family 'Lato'
      m-font-size(12,14)
    &:after
      content: ''
      width vw(12px)
      height vw(10px)
      background-image url('~@/assets/icons/arrow-blue.svg')
      background-position center center
      background-size contain
      background-repeat no-repeat
      position absolute
      left 50%
      top vh(20px)
      transform translate(-50%,0)
</style>
